import { Component, Input, Optional, Self } from '@angular/core';
import {
  NgControl,
  ControlValueAccessor,
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  FormGroupDirective,
  NgForm,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher } from '@angular/material/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'anihis-text-input',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './text-input.component.html',
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() type: string = 'text';

  value: any = '';
  disabled = false;

  onChange = (_: any) => {};
  onTouched = () => {};

  errorStateMatcher: ErrorStateMatcher;

  constructor(@Optional() @Self() public ngControl: NgControl | null) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
    const self = this;
    this.errorStateMatcher = {
      isErrorState(
        _c: FormControl | null,
        _f: FormGroupDirective | NgForm | null,
      ): boolean {
        const outer = self.ngControl?.control;
        if (!outer) return false;
        return outer.invalid && (outer.touched || outer.dirty);
      },
    };
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(value: any) {
    this.value = value;
    this.onChange(value);
  }
}
